import { useState } from 'react';
import { Button } from '../ui/button';
import { useMicrosoftLoginUrl } from '../../hooks/use-auth';

export function StaffLoginForm() {
  const microsoftLogin = useMicrosoftLoginUrl();
  const [error, setError] = useState('');

  const handleLogin = async () => {
    try {
      const result = await microsoftLogin.mutateAsync();
      window.location.href = result.data.url;
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600">
        Autentificați-vă cu contul Microsoft al companiei.
      </p>
      {error && <p className="text-sm text-error">{error}</p>}
      <Button onClick={handleLogin} className="w-full" disabled={microsoftLogin.isPending}>
        <svg viewBox="0 0 21 21" className="h-5 w-5" xmlns="http://www.w3.org/2000/svg">
          <rect x="1" y="1" width="9" height="9" fill="#f25022" />
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
          <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
          <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
        </svg>
        Autentificare cu Microsoft
      </Button>
    </div>
  );
}
